import * as yup from "yup";
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const emailRegexp = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
export const RegisterUserSchema = yup.object({
  name: yup.string().required('Please enter name'),
  mobile: yup.string().required('Please enter mobile number').matches(phoneRegExp, 'Phone number is not valid'),
  email: yup.string().required('Please enter email').matches(emailRegexp, 'Please enter valid email address'),
});

